import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import {TweenMax, Power1} from 'gsap';
import AnimateButtonHelper from 'helpers/utilities/animate-button';

class TransitionLink extends React.Component {
  constructor(props) {
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onClick = this.handleClick.bind(this);
  }

  /**
   * React Lifecycle Hook
   * Invoked once, immediately after the initial rendering occurs.
   *
   * @method  componentDidMount
   */
  componentDidMount() {
    this.initAnimationHelper();
  }

  initAnimationHelper() {
    if (!this.props.animateOnClick) return;

    const animateProps = {
      'button': this.button,
      'buttonFill': this.buttonFill,
      'onComplete': this.handleTransition.bind(this),
    };

    this.animateButtonHelper = new AnimateButtonHelper(animateProps);
  }

  /**
   * React Lifecycle Hook
   * Invoked immediately before a component is unmounted and destroyed.
   * Perform any necessary cleanup in this method
   *
   * @method  componentWillUnmount
   */
  componentWillUnmount() {
    if (!this.props.animateOnClick) return;

    this.animateButtonHelper.disable();
  }

  handleClick(event) {
    event.preventDefault();

    this.handleTransition();

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  handleTransition() {
    if (this.props.history.location.pathname === this.props.to) return;

    if (this.props.target === '_blank') {
      window.open(this.props.to);

      return;
    }

    this.transitionPageOut(() => {
      this.props.history.push(this.props.to);
    });
  }

  transitionPageOut(callback) {
    const $pageHero = document.querySelector('.js-page-hero');
    const $pageContent = document.querySelector('.js-page-main');
    const $pageTexture = document.querySelector('.js-page-texture-bg');

    if ($pageHero) {
      TweenMax.to($pageHero, 0.33, {
        'opacity': 0,
        'ease': Power1.easeIn,
        'onComplete': callback
      });
    }

    if ($pageTexture) {
      TweenMax.to($pageTexture, 0.33, {
        'opacity': 0,
        'ease': Power1.easeIn,
      });
    }

    if ($pageContent) {
      TweenMax.to($pageContent, 0.33, {
        'opacity': 0,
        'ease': Power1.easeIn,
      });
    }
  }

  _renderAnimating() {
    return (
      <span className="btn-container">
        {this._renderStaticButton()}
        <span className="btn-fill" ref={el => { this.buttonFill = el; }}></span>
      </span>
    );
  }

  _renderStaticButton() {
    const { activeClassName, children, history, to } = this.props;
    const linkClasses = classNames(
      this.props.className,
      {
        [activeClassName] : activeClassName && history.location.pathname === to
      }
    );

    return (
      <a
        href={to}
        className={linkClasses}
        ref={el => { this.button = el; }}
        onClick={this.onClick}
      >
        {children}
      </a>
    );
  }

  render() {
    if (this.props.animateOnClick) {
      return this._renderAnimating();
    }
    else {
      return this._renderStaticButton();
    }
  }
}

TransitionLink.propTypes = {
  'activeClassName': PropTypes.string,
  'animateOnClick': PropTypes.bool,
  'onClick': PropTypes.func,
  'target': PropTypes.oneOf(['_blank']),
  'to': PropTypes.string.isRequired
};

const TransitionLinkWithRouter = withRouter(TransitionLink);

export default TransitionLinkWithRouter;



// WEBPACK FOOTER //
// ./src/client/components/transition-link/transition-link.jsx